import CopyButton from "@/components/CopyButton";
import RpIcon from "@/components/RpIcon";
import API from "@/constant/API";
import TransPaymentInfo from "@/pages/card/components/TransPaymentInfo";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader";
import LabelValue from "@/pages/components/LabelValue";
import RecordHeader from "@/pages/components/RecordHeader";
import axiosInstance from "@/utils/axios";
import { toDateTimeString, toListItemDateString } from "@/utils/dateUtils";
import { getIconByBizType, getResourceByMcc, getResourceByMccName, getUrlParams } from "@/utils/utils.js";
import { Box, Button, Divider, Stack, styled, Typography, useTheme } from "@mui/material";
import { useRequest } from "ahooks";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const StyledContainer = styled(Box)(({theme}) => ({
  padding: '16px'
}))

const TransactionDetail = () => {
  const sn = getUrlParams('sn')
  const theme = useTheme();
  const navigate = useNavigate();
  const {t} = useTranslation()
  const getDetailReq = useRequest(async () => {
    const res = await axiosInstance.post(API.ASSETS_TRANS_DETAIL, {sn});
    return res
  })

  const _renderIcon = () => {
    const icon = getIconByBizType(getDetailReq?.data?.businessType);
    return icon ? <RpIcon icon={icon} size={24}/> : <RpIcon icon={"card-consume"} size={24}/>
  }

  const _viewTxLink = () => {
    window.open(getDetailReq?.data.txLink, '_blank');
  }

  if (!getDetailReq?.data) return null;

  const record = getDetailReq?.data;

  return (<>
    <Stack sx={{width: '100%', flex: 1}}>
      <SimpleHeader title={t('transaction_details')} />

      <StyledContainer>
        <RecordHeader iconWidget={_renderIcon()} iconTitle={record.businessTypeDisplayName ?? ''} 
          amount={record.amount} currencyCode={record.varietyCodeShortName} />
      </StyledContainer>

      <Divider sx={{ borderColor: theme.palette.background.paper, borderWidth: '4px' }} />

      <StyledContainer sx={{ flex: 1 }}>
        <Stack spacing={2}>
          <LabelValue label={t("biz_sn")} value={record.businessSn} copyEnable={true} />
          <LabelValue label={t("type")} value={record.businessTypeDisplayName} />
          <LabelValue label={t("create_time")} value={toDateTimeString(record.createTime)} />
          {record.address && <LabelValue label={t("address")} value={record.address} />}
          {record.coin && <LabelValue label={t("network")} value={record!.coinDisplayName ?? record!.coin} />}
        </Stack>
      </StyledContainer>

      {record.txLink && <StyledContainer>
        <Button variant="contained" fullWidth size="large" onClick={_viewTxLink}>
          {t('view_on_blockchain_explorer')}
        </Button>
      </StyledContainer>}
    </Stack>
  </>)
}

export default TransactionDetail;